<template>
	<div>
		<section>
			<div class="inner row5">
				<div class="title">
					<h1>데이터관리</h1>
				</div>
				<section>
					<div class="row4">
						<div class="flex alignLeft">
							<button	class="excelBtn searchBtnCmmn" @click="onClickSearchHistoryDownload('PRODUCT')">제품 검색이력 다운로드</button>
							<button class="excelBtn searchBtnCmmn" @click="onClickSearchHistoryDownload('SERVICE')">서비스 검색이력 다운로드</button>
						</div>
						<div class="topContent flex">
							<div class="left flex">
								<p>총 <span>{{ totalCnt + surveyCnt }}</span>건</p>
								<p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
								<div class="tops">
                                    <div class="tabMenu secItemMG productHistoryBtnBox">
                                        <button class="accountTabBtn" v-on:click="setTabChangeGo()">
                                            설문지 {{surveyCnt}}
                                        </button>
                                        <button class="accountTabBtn" :class="{active: currentTab===1}">
                                            검색이력 {{totalCnt}}
                                        </button>
                                    </div>
                                </div>
							</div>
							<div>
								<input type="text" class="searchInput" v-model="searchText" @keyup.enter="onClickSearch"/>
								<input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
								<input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
							</div>
						</div>
						<div class="joinTabContent">
							<div class="tableContainer">
								<div class="sampleTemplate">
									<b-table
										ref="table"
										:fields="fields"
										:items="getItems"
										:per-page="perPage"
										:current-page="currentPage"
										hover
										show-empty
										empty-text="데이터가 존재하지 않습니다.">

										<template #emptyfiltered="scope">
											<h4>{{ scope.emptyFilteredText }}</h4>
										</template>

										<template #cell(INDEX)="data">
											{{ data.index + 1 }}
										</template>

										<template #cell(SHOW_DETAIL)="row">
											<b-button size="sm" @click="onClickShowDetail(row)" class="mr-2">
												상세보기
											</b-button>
										</template>
									</b-table>

									<b-pagination
										v-model="currentPage"
										:total-rows="totalCnt"
										:per-page="perPage"
										aria-controls="table">
									</b-pagination>
								</div>
								<DataHistoryManagementModal v-if="isShowModal" v-bind:userIdx='userIdx'  @modal-closed="handleModalClosed"/>
							</div>
						</div>
					</div>
				</section>
			</div>
		</section>
	</div>   
</template>

<script>
import axios from '@/axios/axios'
import DataHistoryManagementModal from '@/components/dataManagement/ModalDataHistoryManagement'
import {mapActions} from 'vuex'

export default {
	name: 'Home',
	components:{
		DataHistoryManagementModal
	},
	data() {
		return {
			currentTab: 1,
			perPage: 10,
			currentPage: 1,
			totalCnt: 0,
			surveyCnt: 0,
			sortBy: 'IDX',
			sortDesc: false,
			searchText : "",
			fields: [
				{
					key: 'INDEX',
					label: 'No',
					class: 'text-center'
				},
				{
					key: 'ID',
					label: '아이디',
					isActive: true,
					class: 'statusOn text-center'
				},
				{
					key: 'NAME',
					label: '이름',
					class: 'text-center'
				},
				{
					key: 'PRODUCT_COUNT',
					label: '제품 수',
					class: 'text-center'
				},
				{
					key: 'SERVICE_COUNT',
					label: '서비스 수',
					class: 'text-center'
				},
				{
					key: 'SHOW_DETAIL',
					label:'상세보기',
					class: 'text-center'
				}
			],
			isShowModal: false,
			userIdx: null
		}
	},
	computed:{
		totalPage(){
			if(this.totalCnt == 0 ) return 1;
			else if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage;
			else return Math.floor(this.totalCnt/this.perPage) + 1;
		}
	},
	methods:{
		...mapActions('searchHistory', [
			'searchHistoryDownload'
		]),
		getItems(){
			return axios
                .post('/api/admin/searchHistry/getUserList', {
                    currentPage: this.currentPage,
                    perPage: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    searchText : this.searchText,
                    roleName : ""
                })
                .then(response => {
                    const items = response.data.items;
                    this.totalCnt = response.data.totalCnt;
                    this.surveyCnt = response.data.surveyCnt;

                    return items;
                })
                .catch(error => {
					console.log(error)
                    this.$alert("알림", "데이터 검색이력 조회에 실패했습니다.");
                    return []
                });
		},
		onClickSearch(){
			this.$refs.table.refresh()
		},
		onClickReset(){
			this.perPage = 10;
			this.currentPage = 1;
			this.totalCnt = 0;
			this.sortBy = 'IDX';
			this.sortDesc = true;
			this.searchText = "";
			
			this.$refs.table.refresh()
		},
		handleModalClosed(value, param){
			if(value === DataHistoryManagementModal.name){
				this.isShowModal = false

				if(param.result == true){
					this.$refs.table.refresh()
				}
			}
		},
		setTabChangeGo() {
			this.$router.push({ path:'/admin/dataManagement'});
		},
		onClickShowDetail(row){
			this.userIdx = row.item.IDX;
			this.isShowModal = true;
		},
		onClickSearchHistoryDownload(type){
			this.searchHistoryDownload(type)
			.catch(() => {
				this.$alert('알림', '데이터를 가져올 수 없습니다.')
			})
		}
	}
}
</script>

<style scoped lang="scss">
	.sampleTemplate ::v-deep {
		@import "~bootstrap/dist/css/bootstrap.min";
		@import "~bootstrap-vue/dist/bootstrap-vue.min";
	}
</style>